import { useEffect, useRef, useState } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";
import { DateRange } from "react-day-picker";

import { useMouseContent } from "src/utils/mouse/mouseContent";
import { SearchSection_SYS3050_R01 } from "./SearchSection_SYS3050_R01";
import { useSYS3050_R01Store } from "src/containers/mes/SYS/SYS3050_R01/Store_SYS3050_R01";
import { SYS3050_R01Content } from "./Content_SYS3050_R01";
import { SYS3050_R01Info } from "./Info_SYS3050_R01";
import { SYS3050_R01Table } from "./Table_SYS3050_R01";
import { AgGridReact } from "ag-grid-react";
import { SYS3050_R01Dto } from "./Dto_SYS3050_R01";


export const Container_SYS3050_R01 = () => {


	const {
		editSYS3050_R01,
		SYS3050_R01List,
		allCount,
		initData,
	} = useSYS3050_R01Store();
	
	

	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,
		create: false,
		delete: false,
		save: false,
		print: false,
		excel: false,
		init: false
	});

	useEffect(() => {
		setButtonDisabled({
			fetch: false,
			create: false,
			delete: SYS3050_R01List.length < 1 && (editSYS3050_R01?.empNo === '' || editSYS3050_R01?.empNo === undefined) ? true : false,
			save: SYS3050_R01List.length < 1 && (editSYS3050_R01?.empNo === '' || editSYS3050_R01?.empNo === undefined) ? true : false,
			print: SYS3050_R01List.length < 1 ? true : false,
			excel: SYS3050_R01List.length < 1 ? true : false,
			init: false
		});
	}, [SYS3050_R01List.length, editSYS3050_R01?.empNo]);

    const RESIZER = {
        code: 'SYS3050_R01',  // 컴포넌트 코드
        type: 'width',        // 리사이저 타입 (width/height)
        storageKey: 'SYS3050_R01-split-width',  // localStorage 키
        min: 5,              // 최소 너비
        max: 80,             // 최대 너비
        default: 35          // 기본 너비
    } as const;

	const gridRef = useRef<AgGridReact<SYS3050_R01Dto>>(null);
	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);


	const {
		handleExcelClick,
		fetchData,
		defaultSYS3050_R01Row,
		initContainerData,
		handleCreateClick,
		handleDeleteClick,
		handleSaveClick,
	} = SYS3050_R01Content({
		gridRef,
	});
  
	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});


	return(
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleCreateClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onExcelClick={handleExcelClick}
				onInitClick={initContainerData}
			/>
			<SearchSection_SYS3050_R01
				onEnterKeyDown={fetchData} 
			/>
			<div className="flex flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
				<div className="h-full" style={{ width: `${splitValue}%` }}>
					<SYS3050_R01Table gridRef={gridRef} defaultSYS3050_R01Row={defaultSYS3050_R01Row()} />
				</div>
				{/* 리사이저 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
					// 드래그 시작 방지
					onDragStart={(e: React.DragEvent<HTMLDivElement>) => e.preventDefault()}
				/>
				<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
					<SYS3050_R01Info defaultSYS3050_R01Row={defaultSYS3050_R01Row()}/>
				</div>
			</div>
			<Message />
		</div>
	)
}